import { createContext, useContext, useEffect, useState } from "react";
import { api, setApiRegion } from "../lib/api";
import { setFormatRegion } from "../lib/format";
import { Spinner } from "../components/common";

const RegionContext = createContext(null);

// Region comes from the URL prefix (/mallorca/...), then the subdomain (mallorca.example.com), then the env default.
function resolveSlug(slugs) {
  const first = window.location.pathname.split("/").filter(Boolean)[0];
  if (slugs.includes(first)) return { slug: first, basename: `/${first}` };
  const sub = window.location.hostname.split(".")[0];
  if (slugs.includes(sub)) return { slug: sub, basename: "" };
  return { slug: process.env.REACT_APP_DEFAULT_REGION, basename: "" };
}

export function RegionProvider({ children }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    let timer;
    const load = () =>
      api.get("/regions").then(({ data }) => {
        const { slug, basename } = resolveSlug(data.map((r) => r.slug));
        const region = data.find((r) => r.slug === slug) || data[0];
        setApiRegion(region.slug);
        setFormatRegion(region);
        setState({ region, basename });
      }).catch(() => (timer = setTimeout(load, 2000)));
    load();
    return () => clearTimeout(timer);
  }, []);
  if (!state) return <div className="flex min-h-[100dvh] items-center justify-center"><Spinner /></div>;
  return <RegionContext.Provider value={state}>{children}</RegionContext.Provider>;
}

export const useRegion = () => useContext(RegionContext);
